// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReducedPolicyStatusDto } from './IReducedPolicyStatusDto';
import {
    IReducedPolicyStatusDtoFromJSON,
    IReducedPolicyStatusDtoFromJSONTyped,
    IReducedPolicyStatusDtoToJSON,
    IReducedPolicyStatusDtoToJSONTyped,
} from './IReducedPolicyStatusDto';

/**
 * 
 * @export
 * @interface IReducedPolicyDto
 */
export interface IReducedPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof IReducedPolicyDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReducedPolicyDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReducedPolicyDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IReducedPolicyDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IReducedPolicyDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReducedPolicyDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReducedPolicyDto
     */
    organization_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IReducedPolicyDto
     */
    oldest_election_valid_from?: Date;
    /**
     * 
     * @type {string}
     * @memberof IReducedPolicyDto
     */
    account_type?: IReducedPolicyDtoAccountTypeEnum;
    /**
     * 
     * @type {IReducedPolicyStatusDto}
     * @memberof IReducedPolicyDto
     */
    first_status?: IReducedPolicyStatusDto;
    /**
     * 
     * @type {IReducedPolicyStatusDto}
     * @memberof IReducedPolicyDto
     */
    current_status?: IReducedPolicyStatusDto;
    /**
     * 
     * @type {IReducedPolicyStatusDto}
     * @memberof IReducedPolicyDto
     */
    latest_status?: IReducedPolicyStatusDto;
}

/**
* @export
* @enum {string}
*/
export enum IReducedPolicyDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IReducedPolicyDto interface.
 */
export function instanceOfIReducedPolicyDto(value: object): value is IReducedPolicyDto {
    return true;
}

export function IReducedPolicyDtoFromJSON(json: any): IReducedPolicyDto {
    return IReducedPolicyDtoFromJSONTyped(json, false);
}

export function IReducedPolicyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReducedPolicyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'oldest_election_valid_from': json['oldest_election_valid_from'] == null ? undefined : (new Date(json['oldest_election_valid_from'])),
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'first_status': json['first_status'] == null ? undefined : IReducedPolicyStatusDtoFromJSON(json['first_status']),
        'current_status': json['current_status'] == null ? undefined : IReducedPolicyStatusDtoFromJSON(json['current_status']),
        'latest_status': json['latest_status'] == null ? undefined : IReducedPolicyStatusDtoFromJSON(json['latest_status']),
    };
}

export function IReducedPolicyDtoToJSON(json: any): IReducedPolicyDto {
    return IReducedPolicyDtoToJSONTyped(json, false);
}

export function IReducedPolicyDtoToJSONTyped(value?: IReducedPolicyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_id': value['plan_id'],
        'plan_code': value['plan_code'],
        'plan_name': value['plan_name'],
        'employee_id': value['employee_id'],
        'account_id': value['account_id'],
        'organization_id': value['organization_id'],
        'oldest_election_valid_from': value['oldest_election_valid_from'] == null ? undefined : ((value['oldest_election_valid_from']).toISOString().substring(0,10)),
        'account_type': value['account_type'],
        'first_status': IReducedPolicyStatusDtoToJSON(value['first_status']),
        'current_status': IReducedPolicyStatusDtoToJSON(value['current_status']),
        'latest_status': IReducedPolicyStatusDtoToJSON(value['latest_status']),
    };
}

